import { RegionUsageRestrictions } from 'js/project/nds/types/regionUsageRestrictions';
import fetchWrapper from '../fetchWrapper';

export function fetchRegionUsageRestrictions(groupId: string): Promise<RegionUsageRestrictions> {
  return fetchWrapper(`/nds/${groupId}/regionUsageRestrictions`, {
    method: 'GET',
  }).then((resp) => resp.json());
}
